import * as actions from './constants';

const defaultState = {
    isAuthenticated: false,
    checked: false, // has the boot-time / login / refresh cycle resolved at least once
    userId: null,
    expiresIn: null,
    error: null,
    loading: false
}

export default function(state = defaultState, action) {
    const { type, payload=null, error=null } = action;
    switch (type) {
        case actions.AUTH_RESET: {
            // Dispatched every time the login form mounts, just to clear a stale
            // error/loading from a previous attempt - must not touch isAuthenticated/
            // checked/userId, or it wipes out the boot-check result (nothing re-runs
            // checkAuth() afterwards, so `checked` would never become true again).
            return {
                ...state,
                error: null,
                loading: false
            }
        }
        case actions.AUTH_START:
        case actions.AUTH_CHECK_START:
            return {
                ...state,
                loading: true
            }
        case actions.AUTH_SUCCESS:
        case actions.AUTH_CHECK_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
                checked: true,
                loading: false,
                expiresIn: payload?.expires_in ?? state.expiresIn,
                userId: payload?.userId ?? state.userId
            }
        case actions.AUTH_FAILURE:
            return {
                ...state,
                loading: false,
                error
            }
        case actions.AUTH_CHECK_FAILURE:
        case actions.AUTH_CLEAN:
            return {
                ...defaultState,
                checked: true // never reset to false, or PrivateRoute hangs in "checking"
            }
        default:
            return state;
    }
}
